import { IDashRegistrationLog } from "./dash-registration-log";
import { IDonorConnectCenterStats } from "./donor-connect-center-stats";
import { IDonorConnectCenterContacts } from "./donor-connect-center-contacts";
import { ConnectToDonorMilestone, MentorEducationChoice } from "../enums/index";
import { IGambitData } from "./gambit-data";

export interface IDonorConnect {
    id: number,
    firstName: string,
    lastName: string,
    preferredName: string,
    email: string,
    mobileAuthCode: string,
    birthDate: string,
    gender: string,
    mobileNumber: string,
    phoneNumber: string,
    phoneNumberSecondary: string,
    city: string,
    state: string,
    postalCode: string,
    timezone: string,
    isResidingInUsa?: boolean,
    centerId: number,
    centerAlias: string,
    centerName: string,
    entrySource: string,
    hasNutcracker: boolean,
    entryReferrerSrcCode: string,
    isClm: boolean,
    connectToDonorOffer: boolean,
    connectToDonorStatusId: number,
    connectToDonorStatus: string,
    connectToDonorAcceptedDate: string,
    connectToDonorAssignedUserId: number,
    connectToDonorAssigndUser: {
        firstName: string,
        lastName: string,
    },
    connectToDonorNextFollowUpDate: string,
    connectToDonorMilestone: ConnectToDonorMilestone,
    connectToDonorMilestoneDescription: string,
    connectToDonorNextMilestone: ConnectToDonorMilestone,
    connectToDonorNextMilestoneDescription: string,
    connectToDonorMilestoneCanProgress: boolean,
    connectToDonorGroupId: number,
    connectToDonorGroup: string,
    logs: IDashRegistrationLog[],
    hasDuplicate: boolean,
    donationType: number,
    donationTypeAbbr: string,
    donationTypeId: number,
    donatedDate: string,
    closeLoopSurgeryDateTime,
    closeLoopEntityType,
    closeLoopEntityTypeId,
    mentorDonationLogged?: boolean,
    mentorDonationCenterId?: number,
    mentorDonationDate?: string,
    mentorDonationTypeId,
    recipientCenterAlias: string,
    recipientCenterId: number,
    mentorEducationChoiceId: number,
    mentorEducationChoice: string,
    voucherEducationChoiceId: number,
    voucherEducationChoice: string,
    registrationDate: string,
    intakeCompleteDate: string,
    screeningCompleteDate: string,
    pwlProcess: string;
    donorSituationId: number,
    donorSituation: string,
    centerStats: IDonorConnectCenterStats,
    recipientCenterStats: IDonorConnectCenterStats,
    centerContacts: IDonorConnectCenterContacts[],
    recipientCenterContacts: IDonorConnectCenterContacts[],
    postTxp: boolean,
    receivedVoucher: boolean,
    stopCommunication: boolean,
    canSendMentorEmail: boolean,
    mentorEmailBlockedReason?: string,
    
    // Gambit Data
    dashGambitData: IGambitData[]
}

export interface IDonorConnectCounts {
    unassignedCount: number,
    toDoCount: number,
    assignedToMeCount: number,
    allCount: number
}

export interface IDonorConnectCompletionsReport {
    userId: number,
    username: string,
    firstContactsAssigned: number,
    firstContactAttempts: number,
    firstContactsMade: number,
    surveysCompletedForWorkup: number,
    surveysCompletedForPreOp: number,
    surveysCompletedAtSurgery: number,
    surveysCompletedPostSurgery: number,
}
